// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"715c8bf5","344":"9da59eb0","453":"1407b060","471":"b767320f","553":"8dad5f8e","594":"725b638f","963":"86862c31"}[chunkId] + ".chunk.js";
};